import {Component, Input} from '@angular/core';
import {ImageService} from '../../service/ImageService';
import { AlbumSummaryWithArtist } from 'src/app/model/AlbumSummaryWithArtist';

@Component({
  selector: 'app-album-card-with-artist',
  templateUrl: './album-card-with-artist.component.html',
  styleUrls: ['./album-card-with-artist.component.scss']
})
export class AlbumCardWithArtistComponent {

  @Input() album: AlbumSummaryWithArtist;

  constructor(
    private imageService: ImageService
  ) {
  }

  getAlbumImg(artistId: string, albumId: string): string {
    return this.imageService.getSmallAlbumCoverImg(artistId, albumId);
  }

}
